import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import {
  TERMS_MODULE_LABELS,
  resolveTermsModuleFromPath,
} from "../../constants/cms";
import { fetchTermsAcceptanceStatus } from "../../services/cms.service";
import ModuleTermsAcceptanceModal from "./ModuleTermsAcceptanceModal";

const TOKEN_COOKIE = "auth_token";

export default function ModuleTermsAcceptanceGate({ children }) {
  const { pathname } = useLocation();
  const [checking, setChecking] = useState(false);
  const [blocked, setBlocked] = useState(false);
  const [moduleName, setModuleName] = useState(null);

  const moduleLabel = useMemo(
    () => (moduleName ? TERMS_MODULE_LABELS[moduleName] || moduleName : ""),
    [moduleName],
  );

  const checkAcceptance = useCallback(async () => {
    const token = Cookies.get(TOKEN_COOKIE);
    const resolvedModule = resolveTermsModuleFromPath(pathname);
    setModuleName(resolvedModule);

    if (!token || !resolvedModule) {
      setBlocked(false);
      return;
    }

    setChecking(true);
    try {
      const status = await fetchTermsAcceptanceStatus(resolvedModule);
      setBlocked(Boolean(status?.requiresAcceptance));
    } catch {
      setBlocked(false);
    } finally {
      setChecking(false);
    }
  }, [pathname]);

  useEffect(() => {
    checkAcceptance();
  }, [checkAcceptance]);

  const handleAccepted = () => {
    setBlocked(false);
  };

  if (checking) {
    return (
      <div className="terms-acceptance-gate-loading" aria-live="polite">
        Checking terms acceptance...
      </div>
    );
  }

  return (
    <>
      <div className={blocked ? "terms-acceptance-gate--blocked" : ""}>{children}</div>
      <ModuleTermsAcceptanceModal
        open={blocked}
        moduleName={moduleName}
        moduleLabel={moduleLabel}
        onAccepted={handleAccepted}
      />
    </>
  );
}
